<template>
  <div id="app">
    <div class="layout-container">
      <Header></Header>
      <NavBar />
      <div class="layout-content">
        <LeftNav
          v-if="$route.path != '/' && $route.path != '/contact-us' && $route.path != '/more' && $route.path != '/detail'"
        />
        <router-view />
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";
import LeftNav from "@/components/LeftNav";
import { getNavTreeData, getIndex } from "./api/common";

export default {
  components: {
    Header,
    NavBar,
    Footer,
    LeftNav,
  },
  data() {
    return {
      logo: "",
      headerBg: "",
    };
  },

  mounted() {
    getIndex().then((res) => {
      if (res.code == 1) {
        // res.obj.photoUpList = this.convertToTwoDimensionalArray(res.obj.photoUpList, 3);
        // res.obj.photoDownList = this.convertToTwoDimensionalArray(res.obj.photoDownList, 3);
        //photoList 等于photoUpList加上photoDownList
        if (res.obj.photoUpList.length && res.obj.photoDownList.length) {
          let photoList = res.obj.photoUpList.concat(res.obj.photoDownList);
          res.obj.photoList = this.convertToTwoDimensionalArray(photoList, 3);
        } else {
          res.obj.photoList = [];
        }
        this.$store.commit("appState/setAppData", res.obj);
      }
    });

    setTimeout(() => {
      getNavTreeData().then((res) => {
        if (res.code == 1) {
          let menuArray = [...res.obj];
          for (let i = 0; i < menuArray.length; i++) {
            menuArray[i].id = menuArray[i].id + "";
            if (menuArray[i].children && menuArray[i].children.length) {
              for (let j = 0; j < menuArray[i].children.length; j++) {
                menuArray[i].children[j].id = menuArray[i].children[j].id + "";
              }
            }
            if (this.$route.path === menuArray[i].href) {
              menuArray[i].active = true;
            } else if (menuArray[i].href == this.$route.query.from) {
              menuArray[i].active = true;
            } else {
              menuArray[i].active = false;
            }
          }
          this.$store.commit("menuState/setMenu", menuArray);
        }
      });
    }, 100);
  },

  methods: {
    convertToTwoDimensionalArray(arr, columns) {
      var result = [];
      for (var i = 0; i < arr.length; i += columns) {
        result.push(arr.slice(i, i + columns));
      }
      return result;
    },
  },
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}

.layout-container {
  width: 100%;

  .layout-content {
    width: 1200px;
    margin: 0 auto;
    min-height: 700px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}
</style>
